export default "__VITE_ASSET__DA1pJZfS__"